import BaseModal from '../Shared/BaseModal.js';
import { useEffect, useState } from "react";
import { RoundedButton, ButtonColor, ButtonCorner } from '../Buttons/RoundedButton.js';
import SubscriptionsDevicesTable from './SubscriptionsDevicesTable.js';
import {
    Container,
    Row,
    Col,
    Spinner
} from "reactstrap";
import SearchBar from "../../components/SearchBar/SearchBar";

const DeactivateDevicesModal = (
    {
        isOpen,
        licenseDiffernce,
        isLoading,
        statusChange,
        subscriptions,
        filteredDevices,
        submitHandler,
        handleClose,
        setSearchTerm
    }) => {
    const nonBreakingSpace = "\u00A0";
    

    

    const headerContent =
        <Container>
            <Row>
                <Col className="d-flex centered-flex-content">
                    <h5 className="modal-title text-black">{licenseDiffernce < 0 ? "Deactivate" : "Activate"} Device Licenses</h5>
                </Col>
            </Row>

        </Container>;

    const DifferenceText = () => {
        if (licenseDiffernce < 0) {
            return <span className="h4 ml-5">Please uncheck <span className="text-red">{Math.abs(licenseDiffernce)} license(s) </span>  you'd like to deactivate.</span>;
        }
        else {
            return <span className="h4 ml-5">Please check <span className="text-green">{licenseDiffernce} license(s) </span>  you'd like to activate.</span>;
        }
    }

    const ExplainText = () => {
        if (licenseDiffernce < 0) {
           return <Row><small><span className="required-indicator-no-padding ml-5">*</span>Removed Licenses will be canceled at the start of the next billing cycle.</small></Row>
        }
        else {
            return <Row><small><span className="required-indicator-no-padding ml-5">*</span>If they aren't set up yet, you can activate your licenses from the Devices & Subscriptions page.</small></Row>
        }
    }

    const bodyContent =
        <>
            <Container className="no-margin-x">
                {isLoading &&
                    <Spinner className="centered-loader" />
                }
                {!isLoading &&
                    <>
                        <Row className="">
                            <DifferenceText />

                        </Row>
                        <ExplainText />
                        <Row>{nonBreakingSpace}</Row>
                        <Row className="ml-4">
                            <SearchBar placeholder="Search Devices" className="align-self-end" changeSearchInput={setSearchTerm} debounceTimeMS={1000} />
                        </Row>
                        <Row>{nonBreakingSpace}</Row>
                        <SubscriptionsDevicesTable
                            devices={filteredDevices}
                            subscriptions={subscriptions}
                            checkChangedHandler={statusChange}
                        />
                        <Row className="d-flex justify-content-end mr-5">
                            <RoundedButton
                                hoverColor={ButtonColor.DeleteRed}
                                hoverTextColor={ButtonColor.White}
                                hoverOutlineColor={ButtonColor.DeleteRed}
                                buttonColor={ButtonColor.White}
                                textColor={ButtonColor.Red}
                                className="mr-3"
                                outlineColor={ButtonColor.DeleteRed}
                                cornerRadius={ButtonCorner.SevenPX}
                                clickHandler={handleClose}
                                type="button"
                                width="100px"
                                text="Cancel" />
                            <RoundedButton
                                hoverColor={ButtonColor.Black}
                                hoverTextColor={ButtonColor.White}
                                hoverOutlineColor={ButtonColor.Black}
                                textColor={ButtonColor.White}
                                buttonColor={ButtonColor.DarkBlue}
                                outlineColor={ButtonColor.DarkBlue}
                                disabledColor={ButtonColor.LightGrey}
                                cornerRadius={ButtonCorner.SevenPX}
                                clickHandler={submitHandler}
                                type="button"
                                width="150px"
                                text="Confirm Changes"
                                disabled={licenseDiffernce < 0}
                            />
                        </Row>
                    </>
                }
            </Container>
        </>
    return (
        <>
            <BaseModal
                headerClassName="background-color-lightGray"
                isOpen={isOpen}
                toggle={handleClose}
                headerContent={headerContent}
                bodyContent={bodyContent}
                size="lg"
                bodyClassName="no-margin-x"
            />
        </>

    );
}

export default DeactivateDevicesModal;